const NAUTILUS_STORAGE_DOMAIN = "https://s3-west.nrp-nautilus.io";
const CDN_DOMAIN = "https://nautilus-assets.b-cdn.net";
const GEODATALAKE_BUCKET = "vizlab-geodatalake-exports";

export function cdnUrl(path: string) {
  const domain =
    process.env.NODE_ENV === "production"
      ? CDN_DOMAIN
      : NAUTILUS_STORAGE_DOMAIN;
  return `${domain}/${GEODATALAKE_BUCKET}/${path}`;
}
